module.exports = __webpack_public_path__ + "media/images/icon_map_marker-053dd208f9182b89351d6256eecafc88.svg";